const namespace = {
  title: "Écoles à proximité",
  noData: "Il n'y a pas d'écoles disponibles à proximité.",
  noFilteredData:
    "Aucune école à proximité ne correspond à vos filtres actuels.",
  english: "Anglais",
  french: "Français",
  board: "Commission scolaire ou district",
  headers: {
    name: "Nom",
    type: "Type",
    languages: "Langues",
    levels: "Niveaux",
    category: "Catégorie",
    address: "Adresse",
    typesFilter: "Tous types",
    levelsFilter: "Tous niveaux",
  },
  categories: {
    advancedPlacement: "Placement avancé",
    charter: "À charte",
    magnet: "À vocation particulière",
  },
  dataDisclaimer:
    "Les écoles sont sélectionnées pour être affichées en fonction de leur proximité avec le lieu. Veuillez contacter directement les écoles pour vérifier les zones de fréquentation.",
} as const;

export default namespace;
